/**
 * PlaceholderPage — minimalny placeholder dla modułów w budowie.
 *
 * Bez opisów, bez przykładowych danych, bez marketingu — wyłącznie:
 *   - nagłówek
 *   - badge "W budowie"
 *   - disabled button "Niedostępne"
 */
import { Construction } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PlaceholderPage = ({ title, testId }) => {
  return (
    <div className="space-y-6" data-testid={testId || "placeholder-page"}>
      <div className="flex items-center gap-3 flex-wrap">
        <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900">{title}</h1>
        <span
          className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-amber-50 text-amber-700 border border-amber-200"
          data-testid="placeholder-badge"
        >
          <Construction className="w-3.5 h-3.5" />
          W budowie
        </span>
      </div>

      <Button
        type="button"
        disabled
        data-testid="placeholder-disabled-btn"
        className="bg-gray-300 text-gray-600 cursor-not-allowed hover:bg-gray-300"
      >
        Niedostępne
      </Button>
    </div>
  );
};

export default PlaceholderPage;
